<template>
  <div class="contain">
    <!-- 头部 -->
    <head-comp></head-comp>
    <!-- banner图 -->
    <div class="banner-box">
      <img src="../assets/imgs/banner.jpg" alt="">
    </div>
    <!-- 通知 -->
    <div class="column-box" >
      <div class="panel panel-success note"  v-for="(item,index) in newsTab" :key="index" :class="{'comingSchBor':item.name == '入学须知'}">
        <div class="panel-heading" :class="item.name == '新生公告'?'newStu':'comingSch'">
          <h3 class="panel-title">
            <span class="glyphicon glyphicon-bell" aria-hidden="true" ></span> 
            {{item.name}}
            <router-link :to="'/list/'+item.id" class="more">more</router-link>
          </h3>
        </div>
        <div class="panel-body">
          <ul class="note-ul">
            <li v-for="(list,index) in item.arts" :key="index">
              <a href="javascript:;" @click="jumpAtc(list)">
                {{list.name}}
              </a>
              <span>{{item.update_time.slice(0,10)}}</span>
            </li>
          </ul>
        </div>
      </div>
      <!-- 右侧概况 -->
      <div class="super-link">
        <router-link :to="'/list/'+proChar.id"><img src="../assets/imgs/zyts.png"></router-link>
        <router-link :to="'/list/'+schPro.id"><img src="../assets/imgs/xxgk.png"></router-link>
        <router-link :to="'/list/'+comIntr.id"><img src="../assets/imgs/stjs.png"></router-link>
        <router-link :to="'/list/'+schView.id"><img src="../assets/imgs/xymj.png"></router-link>
      </div>
    </div>
    <!-- 通知 -->
    <foot-comp></foot-comp>
       <!-- 提示框 -->
    <tip :tip="tip" v-show="tipShow"></tip>
     <!-- 预加载 -->
    <page-load v-if="loading"></page-load>
  </div>
</template>

<script>
import { getArtCates, getArticles } from "../api/api";
import headComp from "../components/headComp";
import footComp from "../components/footComp";
import pageLoad from "../pageload/pageload";

export default {
  components: {
    headComp,
    footComp,
    pageLoad
  },
  data() {
    return {
      newsTab: [], //保存信息列表信息
      schPro: {}, //学校概况栏目
      proChar: {}, //专业特色栏目
      schView: {}, //校园美景栏目
      comIntr: {}, //社团介绍栏目
      // bgOne: "", //banner背景图1
      bgTwo: "", //banner背景图2

      tip: "", //提示语
      loading: true, //预加载
      tipShow: false, //提示框默认状态
      flag: sessionStorage.getItem("stuInfo")
    };
  },
  created() {
    this._getArtCates(); //获取栏目信息
  },
  methods: {
    //获取栏目信息
    _getArtCates() {
      let teb = JSON.parse(sessionStorage.getItem("teb"));
      this.loading = true;
      if (teb == null) {
        let module = {
          sch_id: 1,
          topic_id: 5
        };
        getArtCates(module)
          .then(res => {
            if (res.status && res.data && res.data.length > 0) {
              sessionStorage.setItem("teb", JSON.stringify(res));
              for (let i = 0; i < res.data.length; i++) {
                if (res.data[i].odx >= 1 && res.data[i].odx <= 2) {
                  //新生公告//入学须知
                  this.newsTab.push(res.data[i]);
                  this._getArticles(res.data[i].id, res.data[i]);
                } else if (res.data[i].visible == 2 && res.data[i].odx == 4) {
                  //图1
                  this._getArticles(res.data[i].id, res.data[i]);
                } else if (res.data[i].visible == 2 && res.data[i].odx == 5) {
                  //图2
                  this._getArticles(res.data[i].id, res.data[i]);
                } else if (res.data[i].id == 153) {
                  //学校概况
                  this.schPro = res.data[i];
                } else if (res.data[i].id == 156) {
                  //专业特色
                  this.proChar = res.data[i];
                } else if (res.data[i].id == 157) {
                  //校园美景
                  this.schView = res.data[i];
                } else if (res.data[i].id == 158) {
                  //社团介绍
                  this.comIntr = res.data[i];
                }
              }
            } else {
              this.loading = false;
              this.tipCtr("暂无数据");
            }
          })
          .catch(err => {
            this.loading = false;
            this.tipCtr("未找到相关数据,请重新加载");
          });
      } else {
        for (let i = 0; i < teb.data.length; i++) {
          if (teb.data[i].odx >= 1 && teb.data[i].odx <= 2) {
            //新生公告//入学须知
            this.newsTab.push(teb.data[i]);
            this._getArticles(teb.data[i].id, teb.data[i]);
          } else if (teb.data[i].visible == 2 && teb.data[i].odx == 4) {
            //图1
            this._getArticles(teb.data[i].id, teb.data[i]);
          } else if (teb.data[i].visible == 2 && teb.data[i].odx == 5) {
            //图2
            this._getArticles(teb.data[i].id, teb.data[i]);
          } else if (teb.data[i].id == 153) {
            //学校概况
            this.schPro = teb.data[i];
          } else if (teb.data[i].id == 156) {
            //专业特色
            this.proChar = teb.data[i];
          } else if (teb.data[i].id == 157) {
            //校园美景
            this.schView = teb.data[i];
          } else if (teb.data[i].id == 158) {
            //社团介绍
            this.comIntr = teb.data[i];
          }
        }
      }
    },
    //获取文章列表
    _getArticles(id, arr) {
      let module = {
        sch_id: 1,
        cate_id: id
      };
      this.loading = false;
      getArticles(module)
        .then(res => {
          if (res.status && res.data && res.data.arts.length > 0) {
            if (res.data.visible == 1) {
              //新生通告
              this.$set(arr, "arts", res.data.arts);
            } else {
              this.bgTwo = res.data.arts[0].des;
            }
          } else {
            this.tipCtr("暂无数据");
          }
        })
        .catch(err => {
          this.tipCtr("未找到相关数据,请重新加载");
        });
    },
    //提示框函数
    tipCtr(text) {
      this.tip = text;
      this.tipShow = true;
      setTimeout(() => {
        this.tipShow = false;
      }, 1200);
    },
    //跳转至文章页面
    jumpAtc(list) {
      this.$router.push({ path: "/article/" + list.cate_id + "/" + list.id });
    }
  }
};
</script>

<style scoped>
.contain {
  position: relative;
}
/*banner*/
.banner-box {
  width: 100%;
  height: 250px;
  border-bottom: 1px #eee solid;
}
.banner-box img {
  width: 100%;
  height: 250px;
}
.banner {
  width: 1200px;
  height: 100%;
  margin: 0 auto;
}
/*栏目内容*/
.column-box {
  width: 1200px;
  margin: 0 auto;
  padding-top: 20px;
  overflow: hidden;
  min-height: 340px;
}
/*通知*/
.note {
  float: left;
  width: 380px;
}
.comingSchBor {
  border-color: #428bca;
}
.newStu {
  background: #5cb85c !important;
}
.comingSch {
  background: #428bca !important;
}
.note .panel-heading {
  padding: 0 15px;
  color: #ffffff;
}
.note h3 {
  height: 40px;
  line-height: 40px;
}
.note h3 span {
  font-size: 20px;
  top: 4px;
  margin-right: 5px;
}
.more {
  float: right;
}
.more:hover {
  color: #fd1;
}
.note .panel-body {
  padding: 5px 15px 0;
}
.note-ul li a {
  color: #333;
  font-size: 14px;
  display: inline-block;
  height: 35px;
  line-height: 35px;
  max-width: 70%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.note-ul li:hover a {
  color: red;
}
.note-ul li span {
  color: #999;
  float: right;
  font-size: 12px;
  line-height: 35px;
}
/*入学须知*/
.panel:nth-child(2n) {
  float: left;
  width: 380px;
  margin-left: 50px;
}
/*图片链接*/
.super-link {
  float: right;
  width: 380px;
}
.super-link a {
  width: 168px;
  height: 148px;
  text-align: right;
  float: right;
  margin-left: 20px;
  margin-bottom: 10px;
}
.note-ul {
  width: 348px;
  height: 240px;
  overflow: hidden !important;
}
</style>



// WEBPACK FOOTER //
// src/view/index.vue